module.exports = __webpack_public_path__ + "img/ds_doris.19ac6de4.jpg";